import React from "react";
import { GlobalBox } from 'components/Box/GlobalBox'
import { useSelector, useDispatch } from "react-redux";
import AssessmentIcon from '@mui/icons-material/Assessment';
import { TableInputs } from "components/CardTable/TableInputs"
import { newDate } from "helpers/dateTools";
import { useSearch } from "hooks/useSearch";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportDigitalInventoryFilters, getReportDigitalInventoryAction } from "redux/actions/Reports/reportDigitalInventory/reportDigitalInventoryActions";

export const ReportDigitalInventoryView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { date, station } = useSelector(({ reportDigitalInventory }) => reportDigitalInventory);

  const handleSubmit = (e, isPdf = true) => {
    e.preventDefault()
    if (!date || !station?.id) {
      setSnackbar("Faltan datos requeridos.", 'warning');
      return;
    }
    dispatch(getReportDigitalInventoryAction({ date, station, isPdf }))
  };

  return (
    <GlobalBox title="Reporte de Inventario Digital" icon={<AssessmentIcon />} >
      {isLoadingComp?.loadingReportDigitalInventory ? <LoadingComponent /> :
        <TableInputs
          reducer="reportDigitalInventory"
          date
          stations
          maxDate={newDate()}
          dispatchAction={setReportDigitalInventoryFilters}
          submitAction={handleSubmit}
          submitButtonName="PDF"
          submitSecond={(e) => handleSubmit(e, false)}
        />
      }
    </GlobalBox>
  );
};
